import { render, staticRenderFns } from "./AddUsers.vue?vue&type=template&id=d8519210&scoped=true&"
import script from "./AddUsers.vue?vue&type=script&lang=js&"
export * from "./AddUsers.vue?vue&type=script&lang=js&"
import style0 from "./AddUsers.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddUsers.vue?vue&type=style&index=1&id=d8519210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8519210",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
